/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

import { isOdd } from "helpers/tools/maths";

/**
 * import context
 */

import { AppContext } from "context/appContext";

/**
 * import components
 */

import { Content__product } from "components/content/content";
import { Svg__cross } from "components/svg/svg";
import { Item__rating } from "components/item/item";

/**
 * styled components
 */

const Head = styled.div``;
const Row = styled.div`
  ${t.mixins.flex({ justify: "baseline" })}
`;
const Cell = styled.div`
  min-width: 200px;
  border-right: 1px solid ${t.color.greyGallery};

  ${t.mixins.sm(`
    min-width: 134px;
  `)}
  ${({ first }) =>
    first &&
    `
      position: absolute;
      left: 0;
      height: 290px;
      min-width: 159px;
      background-color: ${t.color.greyAlabaster};
      border-right: 0;

      ${t.mixins.sm(`
        display: none;
      `)}

      `}

    ${({ odd }) =>
      odd &&
      `
      ${t.mixins.sm(`
        background-color: ${t.color.lightGrey};
      `)}
      `}
`;
const Delete = styled.div`
  ${t.mixins.flex({ justify: "flex-end" })}
  padding: 4px 5px 0 5px;
`;
const Button = styled.button``;
const HiddenCell = styled(Cell)`
  position: relative;
  left: initial;
  opacity: 0;

  ${t.mixins.sm(`
    display: none;
  `)}
`;
const Rating = styled.div`
  ${t.mixins.flex()}
  padding: 20px 0;
  border-top: 1px solid ${t.color.greyGallery};

  ${t.mixins.sm(`
    border: 0;
  `)}
`;

/**
 * header component is..
 */

const Table__header = ({ data }) => {
  const { removeChoice } = useContext(AppContext);
  const remove = id => removeChoice(id);
  return (
    <Head>
      <Row>
        <Cell first />
        <HiddenCell first />
        {data.map((item, index) => {
          const { novelty, img, range, skus, id, name } = item;
          const odd = isOdd(index);
          return (
            <Cell key={id} odd={odd}>
              <Delete>
                <Button onClick={() => remove(id)}>
                  <Svg__cross color={t.color.tertiary} size={16} />
                </Button>
              </Delete>
              <Content__product novelty={novelty} img={img} range={range} skus={skus} centered />
              <Rating>
                <Item__rating id={id} name={name} centered />
              </Rating>
            </Cell>
          );
        })}
      </Row>
    </Head>
  );
};

export default Table__header;

Table__header.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Table__header.defaultProps = {
  style: {},
};

/*
    import Table__header from 'components/table/header/table__header'
    <Table__header />
  */
